import * as yup from 'yup';
import {
  nameValidation,
  emailValidation,
  phoneNumberValidation,
  codeValidation,
} from './reusable-fields';

export const createOrUpdateCustomerUserRequestBodySchema = yup
  .object({
    body: yup.object({
      customerName: nameValidation(),
      customerCode: codeValidation(),
      contactFirstName: nameValidation(),
      contactLastName: nameValidation(),
      email: emailValidation(),
      phoneNumber: phoneNumberValidation(),
      customerType: yup
        .string()
        .oneOf([
          'internal-customer',
          'external-customer',
          'third-party-customer',
        ])
        .required('Invalid customer type.'),
      unitSystem: yup.string().oneOf(['metric', 'imperial']).required(),
      timeZone: yup.string().required(),
      mineType: yup.string().oneOf(['open_pit', 'underground']).required(),
      shiftDetails: yup.array().of(yup.object().noUnknown(true)).default([]),
      location: yup
        .string()
        .required('Location is required')
        .test(
          'is-location-format',
          'Format must be: City, State, Country',
          (value) => {
            if (!value) return false;
            // Split by comma and ensure we have exactly 3 non-empty parts
            const parts = value.split(',').map((p) => p.trim());
            return parts.length === 3 && parts.every((p) => p.length > 0);
          }
        ),
      driverBehavior: yup.object({
        lowThreshold: yup.number(),
        highThreshold: yup.number(),
      }),
    }),
  })
  .required();

// Synced to backend schema - 2023-05-12
export const updateCustomerRequestSchema = yup.object({
  body: yup.object({
    customerName: nameValidation(),
    contactFirstName: nameValidation(),
    contactLastName: nameValidation(),
    email: emailValidation(),
    phoneNumber: phoneNumberValidation(),
    internalAccountingLink: yup.string(),
    unitSystem: yup.string().oneOf(['metric', 'imperial']),
    preferredTimeDisplayMode: yup
      .string()
      .oneOf(['utc', 'configured', 'local']),
    driverBehavior: yup
      .object({
        lowThreshold: yup.number(),
        highThreshold: yup.number(),
      })
      .optional(),
  }),
});
